<template>
  <div class="menuBody">
     <DailyChargeTree @DailyChargeTree="getMsgFormSon" @Visible="Visible" />
        <ElseChargeDialog  ref="ElseChargeDialog"/>
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="10">
           <div class="PageTabs">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="应收列表" name="first">应收列表</el-tab-pane>
                <el-tab-pane label="其他收费列表" name="second">其他收费列表</el-tab-pane>
                <el-tab-pane label="收款情况查询" name="third">收款情况查询</el-tab-pane>
              </el-tabs>
            </div>
             <el-table  :data="tableData" v-loading="loading"  tooltip-effect="light"   style="overflow-y: scroll;float:right;margin-top:30px" 
  row-key="id"   :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}"  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column label="序号" type="index" width="60"></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceDm" label="票据簿编号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="invoiceHm" label="票据号码" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeName" label="收费项目" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payer" label="付款人" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="roomName" label="房间名称" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="address" label="地址" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="money" label="金额" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="isDay" label="科目代号" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payMethod" label="收费方式" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="zjSkrq" label="收款日期" ></el-table-column>
    <el-table-column show-overflow-tooltip prop="payee" label="收款人" ></el-table-column>
    <el-table-column fixed="right" label="操作" >
    <template slot-scope="scope">
        <el-button @click="delMenu(scope.row)" v-Jurisdiction="'expense:web:cp:dailyCp:otherCancel'" type="danger" icon="el-icon-delete" circle size="small" title="作废"></el-button>
    </template>
    </el-table-column>
  </el-table>
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="float:right;margin-top:25px;">
    </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import ElseChargeDialog from "../common/ElseChargeDialog";
import DailyChargeTree from "../common/DailyChargeTree.vue";

export default {
  name: "ElseCharge",
  components: {DailyChargeTree,ElseChargeDialog},
  data() {
    return {
  activeName: 'second',
      total:0,
      loading:false,
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        BillNumber:"",
        BillStartNum:"",
        BillEndNum:"",
        groupName:"",
        UpCourseCode:"",
        CourseCode:"",
      tableData: [],
      options: [],
        value: '',
      diaLogVisible: false,
      diaLogData: {
        diaLogVisible: false,
        diaLogType: '',
        paramObj: {},
        paramList: [],
      },
      AllData:"",
      taxRateval:"",
       customerId:"",
      roomId:"",
      roomName:"",
      customerName:"",
      roomProperty:"",
      buildArea:"",
      projectId:"",
    }
  },
     watch: {
    //   // 监听路由变化
     "$route.path": function(newVal, oldVal) {
       if(`${newVal}` == "/charge/bills/dailyIndex"){
       this.activeName = "first"
       }else if(`${newVal}` == "/cha/ElseCharge"){
        this.activeName = "second"
       }else if(`${newVal}` == "/cha/ChargSituation"){
        this.activeName = "third"
       }
     },
  
  },
  methods: {
    Visible(val){
      if(val == false){
        this.ShareList()
      }
    },
         handleClick(tab, event) {
        if(this.activeName == "first"){
          this.activeName = "first"
          this.$router.push({name: 'DailyCharge'})
        }else if(this.activeName == "second"){
          this.activeName = "second"
          this.$router.push({name: 'ElseCharge'})
        }else if(this.activeName == "third"){
          this.activeName = "third"
          this.$router.push({name: 'ChargSituation'})
        }
      },
    delMenu(val){
        this.$refs.ElseChargeDialog.title = "作废";
        this.$refs.ElseChargeDialog.dialogVisible = true;
        this.$refs.ElseChargeDialog.formLabelAlign = val;
    },
    getMsgFormSon(data){
      
     if(data.roomId){
       this.loading = true
          this.roomId = data.roomId
          this.roomName = data.roomName
          this.customerId = data.customerId
          this.customerName = data.customerName
          this.roomProperty = data.roomProperty
          this.buildArea = data.buildArea
          this.ShareList()
        }else if(data.orgId != null){
          this.projectId = data.id
        }
      this.AllData = data
    },
    ShareList(){
      let customerId = this.customerId
        this.$http.get(this.$requestUrl.POST_ELSE_CHARGE_LIST+"?"+"customerId"+"="+customerId).then((res) => {
          let data = res.data;
          if (200 === data.code) {
            this.tableData = data.data;
             this.total = data.total
            this.loading = false
          } else {
            this.$message.error(result.msg)
            this.loading = false
          }
        }).catch(() => {
          this.$message.error(this.$errorMessage.SEVER_ERROR)
        })
    },
    NodeData(data){
        // console.log(data,"data")
        this.mangroupId = data.value
        this.mangrouplab = data.label
    },
         handleSizeChange(val) {
           this.loading = true
        // console.log(`每页 ${val} 条`);
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
      this.loading = true
        // console.log(`当前页: ${val}`);
        this.currentPage = val
        this.ShareList()
    },
  },
  mounted() {
    // this.ShareList()
  }
}
</script>

<style lang="scss">
.menuBody {
  width: 100%;
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;

    }
  }

}
.PageTabs{
  width: 100%;
  margin-bottom: 20px;
  .el-tabs__nav-scroll{
    border:none
  }
}
</style>